
export default {
    getCountry:(state) => {
        if(!state.country.code) return null
        return state.countries.find((con) => con.code == state.country.code);
    },
}
